import { useAuth0 } from '@auth0/auth0-react';
import { useBackoffice } from '../../backoffice/useBackoffice';
import { keepPreviousData, useQuery } from '@tanstack/react-query';
import axios from 'axios';

export type BridgOnbaordingStatusDetails = {
  entities: {
    entity: 'customer.individual';
    status: 'success' | 'error';
    details?: Record<string, any>;
  }[];
};

export const useBridgeDetails = (customerId: string) => {
  const { getAccessTokenSilently } = useAuth0();
  const { developerId, isBackofficeOn } = useBackoffice();
  const query = useQuery({
    queryKey: ['bridge-details', developerId, customerId],
    queryFn: async () => {
      const token = await getAccessTokenSilently();
      const res = await axios.get(`${process.env.REACT_APP_BACKEND_API_URL}/customers/${customerId}/bridge`, {
        params: {
          consumerId: developerId,
        },
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      return res.data?.data;
    },
    refetchOnWindowFocus: false,
    placeholderData: keepPreviousData,
    staleTime: 1000 * 60 * 5,
    enabled: isBackofficeOn && !!customerId,
  });

  return query;
};
